import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

interface GetHotelMappingParams {
  hotelId: string
  providerCode: string
}

/**
 * RTK Query API for hotel-to-provider ID mappings.
 * Maps internal hotel IDs to provider-specific hotel IDs based on the provider code.
 * Example: getHotelMapping(\{hotelId: 10000472, providerCode: 'BKS'\})
 */
export const hotelMappingApi = createApi({
  reducerPath: 'hotelMappingApi',
  baseQuery: fetchBaseQuery({baseUrl: '/api/hotel/mapping'}),
  endpoints: builder => ({
    getHotelMapping: builder.query<string, GetHotelMappingParams>({
      query: ({hotelId, providerCode}) => ({
        url: '',
        params: {hotelId, providerCode}
      })
    })
  })
})

export const {useGetHotelMappingQuery} = hotelMappingApi
